import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './customReactDatepicker.css'
import './reports.css';
import benefitsReportIcon from './../../../assets/img/mm/icon-2.png';

class BenefitsIssuanceReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().startOf('year').toDate(),
            userInfo: getLoginDistrictInfo(),
        }
    }

    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }

    downloadReport = () => {
        const { userInfo, startDate } = this.state;
        const districtID = userInfo.districtId;
        const schoolID = parseInt(this.props.selectSchool);
        const selectedYear = startDate ? new Date(startDate).getFullYear() : null;

        let url = `/benefits-issuance-list?exportType=pdf`;

        // District / School logic
        if (schoolID > 0) {
            url += `&districtId=${districtID}&schoolId=${schoolID}`;
        } else {
            url += `&districtId=${districtID}`;
        }

        // ✅ Add year ONLY if selected
        if (selectedYear) {
            url += `&year=${selectedYear}`;
        }

        url += `&access_token=`;

        this.setState({ loading: true });

        get(url)
            .then(res => {
            if (!res.ok) throw Error(res.statusText || 'Failed to download report');
            return res.blob();
            })
            .then(blob => {
            showFile(blob, `Benefits_Issuance_Report_${selectedYear || 'All'}.pdf`);
            this.setState({ loading: false });
            })
              .catch((error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, this.props);
                    this.setState({ loading: false })
                }
                );
    };


    render() {
        const { startDate } = this.state;
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={benefitsReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Benefits Issuance Report</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                                <div className="row form-group">
                                    <label className="col-sm-12 control-label">Select Year</label>
                                    <div className="col-sm-12 ">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={date => this.setState({ startDate: date })}
                                            showYearPicker
                                            dateFormat="yyyy"
                                            className="form-control custom-react-datepicker"
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className='reportCard-widget-meeting-action'>
                                <div className="form-group">
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px 5px 0px 0px' }} onClick={() => {
                                        this.downloadReport(true)
                                    }}>
                                        <i className="fa fa-file-pdf-o" /> Download Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default BenefitsIssuanceReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/benefitsIssuancelistReport.js